"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableFieldFilterDialog = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const Button_1 = __importDefault(require("@material-ui/core/Button"));
const dialog_1 = require("../../dialog/dialog");
const common_types_1 = require("../../../common/common-types");
const event_callback_hook_1 = require("../../../utils/event-callback-hook");
const field_filter_component_1 = require("../../field-filter/field-filter-component");
exports.TableFieldFilterDialog = react_1.forwardRef(function TableFieldFilterDialog({ filtersFields, filters, reset, handleFilterValueChange, handleFilterStateChange, search, }, ref) {
    /**
     * Submits filled filters and refresh source.
     */
    const handleSearch = event_callback_hook_1.useEventCallback(() => {
        var _a;
        search();
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.close();
    });
    /**
     * Reset filters and source into init state.
     */
    const handleReset = event_callback_hook_1.useEventCallback(() => {
        var _a;
        reset();
        (_a = ref.current) === null || _a === void 0 ? void 0 : _a.close();
    });
    /**
     * Handle enter key.
     */
    const handleKeyUp = event_callback_hook_1.useEventCallback((e) => {
        const ENTER = 13;
        if (e.keyCode === ENTER) {
            handleSearch();
        }
    });
    return (react_1.default.createElement(dialog_1.Dialog, { ref: ref, title: react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__TABLE_FIELD_FILTER__DIALOG_TITLE", defaultMessage: "Nastaven\u00ED filtr\u016F" }), showConfirm: false, actions: [
            react_1.default.createElement(Button_1.default, { key: "submit", type: "submit", variant: "outlined", color: "primary", onClick: handleSearch },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__TABLE_FIELD_FILTER__CONFIRM_BUTTON", defaultMessage: "Pou\u017E\u00EDt filtr" })),
            react_1.default.createElement(Button_1.default, { key: "reset", variant: "outlined", onClick: handleReset },
                react_1.default.createElement(react_intl_1.FormattedMessage, { id: "EAS__TABLE_FIELD_FILTER__RESET_BUTTON", defaultMessage: "Zru\u0161it filtry" })),
        ] }, () => (react_1.default.createElement("div", { onKeyUp: handleKeyUp }, (filtersFields !== null && filtersFields !== void 0 ? filtersFields : []).map((filter, index) => {
        var _a, _b;
        return (react_1.default.createElement(field_filter_component_1.FilterComponent, { key: index, filter: {
                ...filter,
                enabled: true,
                operation: (_a = filter === null || filter === void 0 ? void 0 : filter.defaultOperation) !== null && _a !== void 0 ? _a : common_types_1.ApiFilterOperation.EQ,
                value: '',
            }, state: ((_b = filters === null || filters === void 0 ? void 0 : filters[index]) !== null && _b !== void 0 ? _b : {}), onChangeValue: (value) => handleFilterValueChange(index, value), onChangeFilterState: (state) => handleFilterStateChange(index, state) }));
    })))));
});
//# sourceMappingURL=filter-dialog.js.map